import { useState, useRef } from 'react'
import PropTypes from 'prop-types'

// COMPONENTS
import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai'

// STYLES & ASSETS
import styles from './InputField.module.scss'
import { Link } from 'react-router-dom'

const InputField = ({
	id,
	label,
	linkText,
	type,
	placeholder,
	onChange,
	value,
}) => {
	const ref = useRef(null)
	const [passwordVisible, setpasswordVisible] = useState(
		type === 'password' ? true : false
	)

	const passwordToggle = (e) => {
		e.preventDefault()
		setpasswordVisible(!passwordVisible)

		ref.current.type = passwordVisible ? 'text' : 'password'
	}

	return (
		<label htmlFor={id} className={styles.inputField}>
			<div className={styles.labelContainer}>
				<span className={styles.label}>{label}</span>

				<Link to={'#'} className={styles.signUpLink}>
					{linkText}
				</Link>
			</div>

			<div className={styles.inputBox}>
				<input
					ref={ref}
					type={type}
					name={id}
					id={id}
					placeholder={placeholder}
					onChange={onChange}
					value={value}
					className={styles.input}
					required
				/>

				{type === 'password' && (
					<button
						className={`${
							type === 'password' ? styles.toggleBtn : styles.displayNone
						}`}
						onClick={passwordToggle}
					>
						{passwordVisible ? (
							<AiOutlineEye className={styles.visible} />
						) : (
							<AiOutlineEyeInvisible className={styles.invisible} />
						)}
					</button>
				)}
			</div>
		</label>
	)
}

InputField.propTypes = {
	id: PropTypes.string.isRequired,
	label: PropTypes.string.isRequired,
	linkText: PropTypes.string,
	type: PropTypes.string.isRequired,
	placeholder: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
	value: PropTypes.string,
}

export default InputField
